import EditProfilePRPModal from './EditProfilePRPModal';

export default EditProfilePRPModal;
